import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTOR_VOICES_QUERY_KEYS } from "Actors/Api/Queries/actorVoicesQueryKeys";
import {
  putActorsActorIDActorVoicesActorVoiceID,
  type SaveActorVoiceRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

interface UpdateActorVoiceParams {
  actorVoiceID: string;
  request: SaveActorVoiceRequest;
}

export function useUpdateActorVoiceMutation(actorID: string) {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ actorVoiceID, request }: UpdateActorVoiceParams) =>
      putActorsActorIDActorVoicesActorVoiceID(request, actorID, actorVoiceID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { actorVoiceID }) => {
      queryClient.invalidateQueries({
        queryKey: ACTOR_VOICES_QUERY_KEYS.all(actorID),
      });
      queryClient.invalidateQueries({
        queryKey: ACTOR_VOICES_QUERY_KEYS.detail(actorID, actorVoiceID),
      });
    },
  });
}
